import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class SalaryCalculationsTabs extends Vue {

    get tabs() {
        return [
            {
                id: 1,
                name: "Основные"
            },
            {
                id: 2,
                name: "Сотрудники"
            }
        ]
    }

}